import { socketService } from '../socketService';
import { SocketEventType } from '../types';
import { SocketMessage } from '../types';
import { ConversationStatus } from '../../store/chat/types';

interface ConversationStatusPayload {
  conversationId: string;
  status: ConversationStatus;
}

interface ConversationStatusResponse {
  success: boolean;
  error?: string;
}

export const sendConversationStatus = async (
  conversationId: string,
  status: ConversationStatus,
): Promise<void> => {
  const message: SocketMessage<ConversationStatusPayload> = {
    type: SocketEventType.ConversationStatus,
    payload: { conversationId, status },
    timestamp: new Date().toISOString(),
  };

  const response = await socketService.emitWithAck<
    ConversationStatusPayload,
    ConversationStatusResponse
  >(SocketEventType.ConversationStatus, message);
  if (!response.success) {
    throw new Error(`Failed to mark conversation as seen: ${response.error}`);
  }
};
